// Хуки для работы с данными Form1

import { useCallback } from 'react';
import { API_BASE } from '../../../config';
import { branchPickerOptionsForSubject, resolveSubjectRefId } from './pickerHooks';
import { fetchSubjectDataOnce } from './subjectDataApi';

function mapBranchesToOptions(branches) {
  return (branches || []).map((item) => ({
    value: item,
    label: item,
    description: null,
  }));
}

function mapForestsToOptions(forestLocations) {
  return (forestLocations || []).map((item) => ({
    value: item,
    label: item,
    description: null,
  }));
}

// Хук для загрузки зависимых данных
export const useDataLoading = (setDependentDataRef, handbooks = []) => {
  const loadSubjectData = useCallback(
    async (subjectName, subjectId) => {
      const sid =
        subjectId != null && subjectId !== ''
          ? String(subjectId)
          : resolveSubjectRefId(subjectName, handbooks);

      const { ok, data } = await fetchSubjectDataOnce(subjectId, subjectName);

      const apiOrganizations = ok && data?.branches ? mapBranchesToOptions(data.branches) : [];
      const apiForests =
        ok && data?.forest_locations ? mapForestsToOptions(data.forest_locations) : [];

      const handbookOrgs =
        handbooks?.length && sid ? branchPickerOptionsForSubject(handbooks, sid) : [];

      const organizations =
        apiOrganizations.length > 0 ? apiOrganizations : handbookOrgs;

      const shouldPersist = ok || organizations.length > 0 || apiForests.length > 0;
      if (!shouldPersist) {
        return false;
      }

      setDependentDataRef.current((prev) => ({
        ...prev,
        organizations,
        forestDistricts: apiForests.length > 0 ? apiForests : prev.forestDistricts || [],
        subjectDataLoadedFor: sid || prev.subjectDataLoadedFor || '',
      }));

      return true;
    },
    [setDependentDataRef, handbooks]
  );

  const loadForestDistrictData = useCallback(async (forestLocationName) => {
    try {
      const response = await fetch(
        `${API_BASE}/forest-districts/?name=${encodeURIComponent(forestLocationName)}`
      );
      if (response.ok) {
        const responseData = await response.json();
        setDependentDataRef.current((prev) => ({
          ...prev,
          subDistricts: responseData.forest_districts
            ? responseData.forest_districts.map((item) => ({
                value: item.name,
                label: item.name,
                description: null,
              }))
            : [],
        }));
      }
    } catch {
      /* ignore */
    }
  }, [setDependentDataRef]);

  const loadSubDistrictData = useCallback(async (subDistrictName) => {
    try {
      const response = await fetch(
        `${API_BASE}/toponyms/?name=${encodeURIComponent(subDistrictName)}`
      );
      if (response.ok) {
        const responseData = await response.json();
        setDependentDataRef.current((prev) => ({
          ...prev,
          toponyms: responseData.toponyms
            ? responseData.toponyms.map((item) => ({
                value: item.name,
                label: item.name,
                description: null,
              }))
            : [],
        }));
      }
    } catch {
      /* ignore */
    }
  }, [setDependentDataRef]);

  return {
    loadSubjectData,
    loadForestDistrictData,
    loadSubDistrictData,
  };
};
